import { Node_Type } from 'ricos-types';
import React, { useContext, useState, useEffect } from 'react';
import { debounce } from 'lodash';
import { getHost } from 'wix-rich-content-common';
import HtmlComponent from 'wix-rich-content-plugin-html/libs/HtmlComponent';
import { Image } from 'wix-rich-content-ui-components';
import { RicosContext, RicosViewerContext } from 'ricos-context';

const LINK_PREVIEW_TYPE = "wix-draft-plugin-link-preview";

const DEFAULTS = {
  config: {
    alignment: "center",
    size: "content",
    link: {
      target: "_blank",
      rel: ""
    }
  }
};

var styles = {"fontElementMap":"_2W4CT","linkPreview":"LJK5o","linkPreviewImage":"fREkl","linkPreviewInfo":"seevM","linkPreviewTitle":"m-o7Q","ellipsis":"_8VOVL","linkPreviewDescription":"CFeK7","linkPreviewUrl":"NJ8bP"};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const LinkPreviewViewer = ({ componentData, settings, iframeSandboxDomain, helpers }) => {
  var _a;
  const { enableEmbed = true } = settings;
  return enableEmbed && ((_a = componentData.oembed) == null ? void 0 : _a.html) ? /* @__PURE__ */ React.createElement(
    SocialEmbedViewer,
    {
      componentData,
      settings,
      iframeSandboxDomain
    }
  ) : /* @__PURE__ */ React.createElement(LinkPreviewCard, { componentData, helpers });
};
const SocialEmbedViewer = ({ componentData, settings, iframeSandboxDomain }) => {
  const { theme, isMobile } = useContext(RicosContext);
  const htmlCompProps = {
    componentData: __spreadProps(__spreadValues$1({}, componentData), {
      html: unescape(componentData.oembed.html)
    }),
    settings,
    theme,
    isMobile,
    iframeSandboxDomain
  };
  return /* @__PURE__ */ React.createElement(HtmlComponent, __spreadValues$1({}, htmlCompProps));
};
const LinkPreviewCard = ({ componentData, helpers }) => {
  var _a;
  const [imageHeight, setImageHeight] = useState(0);
  const [elementRef, setElementRef] = useState(null);
  const { isMobile } = useContext(RicosContext);
  const linkPreviewStyles = styles;
  useEffect(() => {
    const resizer = (window == null ? void 0 : window.ResizeObserver) && new ResizeObserver(
      debounce((entries) => {
        setImageHeight(Math.round(entries[0].contentRect.height));
      }, 60)
    );
    elementRef && (resizer == null ? void 0 : resizer.observe(elementRef));
    return () => {
      elementRef && (resizer == null ? void 0 : resizer.unobserve(elementRef));
    };
  }, [elementRef]);
  const getUrlForDisplay = (url) => url.replace(/^https?:\/\//, "");
  const onLinkPreviewClick = () => {
    var _a2;
    return (_a2 = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a2.call(helpers, LINK_PREVIEW_TYPE, "Click", componentData.link.url || "");
  };
  const { title, description, thumbnailUrl } = componentData;
  const {
    linkPreview,
    linkPreviewUrl,
    linkPreviewInfo,
    linkPreviewTitle,
    linkPreviewImage,
    linkPreviewDescription
  } = linkPreviewStyles;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ React.createElement(
      "figure",
      {
        className: linkPreview,
        "data-hook": "linkPreviewViewer",
        onClick: onLinkPreviewClick,
        ref: setElementRef
      },
      thumbnailUrl && /* @__PURE__ */ React.createElement(
        Image,
        {
          uri: thumbnailUrl,
          containerProps: {
            style: {
              height: imageHeight,
              width: isMobile ? 110 : imageHeight
            },
            className: linkPreviewImage
          },
          height: imageHeight,
          width: isMobile ? 110 : imageHeight,
          displayMode: "fill",
          alt: title
        }
      ),
      /* @__PURE__ */ React.createElement("section", { className: linkPreviewInfo }, /* @__PURE__ */ React.createElement("div", { className: linkPreviewUrl }, getUrlForDisplay(getHost(componentData.link.url) || ((_a = componentData.link) == null ? void 0 : _a.url))), /* @__PURE__ */ React.createElement("figcaption", { className: linkPreviewTitle }, title), description && /* @__PURE__ */ React.createElement("div", { className: linkPreviewDescription }, description))
    )
  );
};

const LinkPreview = ({ node, nodeIndex, NodeViewContainer }) => {
  const { iframeSandboxDomain, config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    LinkPreviewViewer,
    {
      settings: config[LINK_PREVIEW_TYPE],
      iframeSandboxDomain: iframeSandboxDomain || "",
      componentData: node.linkPreviewData || node.embedData
    }
  ));
};

const nodeViewRenderers = {
  [Node_Type.LINK_PREVIEW]: LinkPreview,
  [Node_Type.EMBED]: LinkPreview
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginLinkPreview = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: LINK_PREVIEW_TYPE,
    nodeViewRenderers
  };
};

export { LINK_PREVIEW_TYPE, pluginLinkPreview };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-link-preview/dist/es/styles.viewer.min.global.css'